import { queryOptions } from '@tanstack/react-query';
import { adjusterReportQueryFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterReportPage/adjusterReportQueryFunction';

export const adjusterReportTabsQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['adjusterReportTabs', id],
    queryFn: () => adjusterReportQueryFunction(id),
  });
